import React from 'react'
import "./SectionFive.scss";
import { Description, GreenSubDescription } from '../../../../../Global/GlobalText';
import { GreyBorderButton, RedBackgroundButton } from '../../../../../Global/GlobalButton';
import axios from 'axios';
import { EXCHNAGE_URL } from '../../../../../../Url/Url';
import { toast } from 'react-toastify';

export const SectionFive = ({ setSelectedButton, handleSubmit, selectedRoundId }) => {



  const token = localStorage.getItem("token");
  const eventIdGet = ((state) => state?.users?.id);
  const eventId = String(eventIdGet);


  return (
    <div>
      <div className="section_five_main">
        <GreenSubDescription>Preparing Data Successfully</GreenSubDescription>
        <div className='section_five_content'>
          <Description>Your Data is ready to export.</Description>
          <Description>Click <b>"Export"</b> to Continue.</Description>
        </div>






      </div>
      <div className="section_five_btn">
        <GreyBorderButton onClick={() => setSelectedButton(4)}>Previous</GreyBorderButton>
        <RedBackgroundButton onClick={handleSubmit}> {/* Add handler here */}
          Export
        </RedBackgroundButton>
      </div>

    </div>
  )
}
